var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPhoneLight = function SvgPhoneLight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 479,
    height: 703,
    viewBox: "0 0 479 703",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 239.321503,
    y1: 701.232283,
    x2: 239.321503,
    y2: 0.232283,
    gradientTransform: "translate(0 701.732282) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 239.321318,
    y1: 697.007674,
    x2: 239.321318,
    y2: -0.268693,
    gradientTransform: "translate(0 701.732282) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f7f7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,111.223998c0-38.582298,0-57.873199,7.50854-72.609501,6.60466-12.962498,17.14346-23.501298,30.105958-30.105958C53.3508.999999,72.641701.999999,111.223999.999999h256.195007c38.582001,0,57.872986,0,72.609009,7.50854,12.962982,6.60466,23.501984,17.14346,30.105988,30.105958,7.509003,14.736301,7.509003,34.027203,7.509003,72.609501v590.776001H1V111.223998Z",
    fill: "none",
    stroke: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72363,110.480002c0-37.018005,0-55.526905,7.20417-69.665802,6.3369-12.437002,16.448501-22.548502,28.885402-28.885501,14.138897-7.204091,32.647797-7.204091,69.665794-7.204091h257.685005c37.018005,0,55.526001,0,69.665009,7.204091,12.436981,6.336999,22.548981,16.448499,28.885986,28.885501,7.20401,14.138897,7.20401,32.647797,7.20401,69.665802v591.520973H4.72363V110.480002Z",
    fill: "url(#linear-gradient1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.773895,27.066399h93.094208c10.282928,0,18.618896,8.335943,18.618896,18.618849h0c0,10.282906-8.335968,18.618851-18.618896,18.618851h-93.094208c-10.282928,0-18.618896-8.335945-18.618896-18.618851h0c0-10.282906,8.335968-18.618849,18.618896-18.618849Z",
    fill: "#f7f7f7"
  })));
};
export default SvgPhoneLight;